import React, { Component } from "react";
import Navbar from "./components/Navbar";
import "./css/App.css";
import Hero from "./components/Hero";
import Block from "./components/Block";
import Menu from "./components/Menu";
import Contact from "./components/Contact";
import Arrow from "./images/Flèche.svg";
import Image1 from "./images/1-WEB_low.jpg";
import Image2 from "./images/2-WEB_low.jpg";
import content from "./content";
import jump from "jump.js";

class App extends Component {
  constructor(props) {
    super(props);
    this.className = "App";
    this.state = {
      lang: "en",
      showMenu: false,
    };
    this.switchLang = this.switchLang.bind(this);
    this.goTo = this.goTo.bind(this);
  }

  componentDidUpdate() {
    const body = document.querySelectorAll("body")[0];
    if (!this.state.showMenu) {
      body.className = body.className.replace(
        new RegExp(
          "(^|\\b)" + "no-scroll".split(" ").join("|") + "(\\b|$)",
          "gi"
        ),
        " "
      );
    } else {
      body.className += " no-scroll";
    }
  }

  switchLang() {
    const lang = this.state.lang === "en" ? "fr" : "en";
    this.setState({ lang });
  }

  goBackToTop() {
    jump("body");
  }

  goTo(id) {
    this.setState({ showMenu: false });
    if (!id || id === "top") return this.goBackToTop();
    const target = document.getElementById(id);
    if (target) {
      jump(target);
    }
  }

  render() {
    return (
      <div className="App">
        {this.state.showMenu && (
          <Menu
            items={content.menu}
            {...this.props}
            goTo={this.goTo}
            closeMenu={() => this.setState({ showMenu: false })}
          />
        )}
        <Navbar
          {...this.props}
          lang={this.state.lang}
          goTo={this.goTo}
          openMenu={() => this.setState({ showMenu: true })}
          switchLang={this.switchLang}
        />
        <Hero
          imageSrc={Image1}
          {...this.props}
          content={content.header}
          isHeader
        >
          <div className="arrow down" onClick={() => this.goTo("who")}>
            <img src={Arrow} alt=">" />
          </div>
        </Hero>
        <Block content={content.who} anchor="who">
          {/* <div className="arrow down" onClick={() => this.goTo("activities")}>
            <img src={Arrow} alt=">" />
          </div> */}
        </Block>
        <Hero imageSrc={Image2} {...this.props} />
        <Block
          content={content.activities}
          anchor="activities"
          className="activities"
        />
        <Block content={content.how} anchor="how" className="how" />
        <Block content={content.ethics} anchor="ethics" className="ethics">
          {/* <div className="arrow down" onClick={() => this.goTo("contact")}>
            <img src={Arrow} alt=">" />
          </div> */}
        </Block>
        <Block anchor="contact" className="contact">
          <Contact content={content.contact} />
          <div className="arrow up" onClick={this.goBackToTop}>
            <img src={Arrow} alt=">" />
          </div>
        </Block>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js